<template>
    <div class="content-i">
        <div class="content-box">
            <top-section></top-section>
            <listing></listing>
        </div>
    </div>
</template>

<script>
import TopSection from './Dashboard/TopSection.vue'
import Listing from './Dashboard/Listing.vue'

export default {
    components: {
        TopSection, Listing
    }
}
</script>
